import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageChangeService {
  private readonly cookieKey = 'gg-lang';
  private currentLang$ = new BehaviorSubject<string>('en');

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private cookieService: CookieService
  ) {
    // On the server, don’t touch cookies → just use 'en'
    if (isPlatformBrowser(this.platformId)) {
      if (!this.cookieService.check(this.cookieKey)) {
        this.cookieService.set(this.cookieKey, 'en', 3650, '/');
      }
      const lang = this.cookieService.get(this.cookieKey) || 'en';
      this.currentLang$.next(lang);
    }
  }

  setLanguage(lang: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.cookieService.set(this.cookieKey, lang, 3650, '/');
    }
    this.currentLang$.next(lang);
  }

  languageChanges() {
    return this.currentLang$.asObservable();
  }

  get currentLang(): string {
    return this.currentLang$.value;
  }
}
